import React, { createContext, useState, useContext } from 'react';
import { trackCtaClick } from '../utils/standardEvents';

// Create the context
const AppContext = createContext();

// Create a provider component
export const AppProvider = ({ children }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  // Function to toggle the chat widget
  const toggleChat = () => {
    console.debug("AppContext: toggleChat invoked", { previousState: isChatOpen, timestamp: Date.now() });
    setIsChatOpen((prevState) => !prevState);
  };

  // Function to open the chat widget with tracking
  const openChat = (triggerContext = {}) => {
    console.debug("AppContext: openChat invoked", {
      triggerContext,
      previousState: isChatOpen,
      timestamp: Date.now()
    });
    // Track chat open as CTA click
    trackCtaClick({
      cta_id: triggerContext.cta_id || 'open_chat',
      cta_text: triggerContext.cta_text || 'Open Chat',
      section_id: triggerContext.section_id || 'chat_trigger',
      page_path: window.location.pathname,
      cta_location: triggerContext.cta_location || 'unknown',
      chat_trigger: triggerContext.trigger || 'direct_call'
    });
    
    setIsChatOpen(true);
  };

  // Function to close the chat widget
  const closeChat = () => {
    console.debug("AppContext: closeChat invoked", { previousState: isChatOpen, timestamp: Date.now() });
    setIsChatOpen(false);
  };

  // Function to scroll to chat launcher and then open it with tracking
  const scrollToAndOpenChat = (triggerContext = {}) => {
    console.debug("AppContext: scrollToAndOpenChat invoked", {
      triggerContext,
      previousState: isChatOpen,
      timestamp: Date.now()
    });
    // Track chat open as CTA click
    trackCtaClick({
      cta_id: triggerContext.cta_id || 'scroll_and_open_chat',
      cta_text: triggerContext.cta_text || 'Start Project',
      section_id: triggerContext.section_id || 'cta_section',
      page_path: window.location.pathname,
      cta_location: triggerContext.cta_location || 'page_cta',
      chat_trigger: 'scroll_and_open'
    });

    const chatLauncher = document.getElementById('chat-launcher-container');
    console.debug("AppContext: scrollToAndOpenChat DOM lookup", {
      chatLauncherFound: Boolean(chatLauncher),
      timestamp: Date.now()
    });
    setIsChatOpen(true);
  };

  // Values to be provided to the context
  const contextValue = {
    isChatOpen,
    toggleChat,
    openChat,
    closeChat,
    scrollToAndOpenChat
  };

  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
};

// Custom hook to use the AppContext
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
